<div class="container-single views-container">
  <div class="row">

    <div class="col-md-12">

      <div class="card">
        <div class="card-header">
          <h5>Search result:</h5>
        </div>
        <div>
          <div class="result">
            @if (showSkeleton | async) {
              <div class="search-skeleton">
              </div>
            }
            @if (items && !items.length && !(showSkeleton | async)) {
              <div class="card-body">
                {{message}}
              </div>
            }
            @if (items && items.length && !(showSkeleton | async)) {
              <div class="list-group list-group-flush">
                @for (searchItem of items; track searchItem) {
                  <a (click)="navigateToItem(searchItem)" class="list-group-item list-group-item-action"
                    >
                    <span class="col1">{{searchItem.result}}</span>
                    <span class="col2">{{searchItem.info}}</span>
                    <span>{{ searchItem.type | translate }} {{ searchItem.status ? '-' :'' }} {{ searchItem.status | translate }}</span>
                  </a>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>